import { RouterProvider } from 'react-router-dom';
import { Providers } from '@/app/providers';
import { createRouter } from '@/app/router';

const router = createRouter();

export const App = () => (
  <Providers>
    <RouterProvider router={router} />
  </Providers>
);

export default App;
